import { reactive, shallowRef, watch } from 'vue'
import { metaKeyboardKey } from './misc'

export interface ActiveKeys {
  shift: boolean
  meta: boolean
}

const activeModifiers = reactive({
  shift: false,
  meta: false,
})
const key = shallowRef<KeyboardEvent['key'] | null>(null)
let isRegistered = false

export function useKeyboard() {
  let onKeyPress:
    | ((key: KeyboardEvent['key'], modified: ActiveKeys) => void)
    | null = null

  function keyUp(e: KeyboardEvent) {
    if (e.key === metaKeyboardKey) {
      activeModifiers.meta = false
    }

    if (e.key === 'Shift') {
      activeModifiers.shift = false
    }

    key.value = null
  }

  function keyDown(e: KeyboardEvent) {
    if (e.key === metaKeyboardKey) {
      activeModifiers.meta = true
    }

    if (e.key === 'Shift') {
      activeModifiers.shift = true
    }

    key.value = e.key
  }

  function register() {
    if (isRegistered) return
    isRegistered = true
    window.addEventListener('keyup', keyUp)
    window.addEventListener('keydown', keyDown)
  }

  function unregister() {
    window.removeEventListener('keyup', keyUp)
    window.removeEventListener('keydown', keyDown)
    isRegistered = false
  }

  watch(key, k => {
    if (!k) return
    onKeyPress?.(k, activeModifiers)
  })

  return {
    register,
    unregister,
    activeModifiers,
    onKeyPress(fn: (key: KeyboardEvent['key'], modifiers: ActiveKeys) => void) {
      onKeyPress = fn
    },
  }
}
